const initialState = {
  userData: "",
  emailData: "",
  eventId: "",
  portfolioId: "",
  newsId: "",
  maincategoryId: "",
  jobId: "",
  createJobData: "",
  teamData: "",
  chatId: "",
  userChatData: "",
  applicants: "",
  emailVerified: "",
  routeData: "",
  access_token: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_USER_DATA":
      return {
        ...state,
        userData: action.payload,
      };
    case "UPDATE_EMAIL_DATA":
      return {
        ...state,
        emailData: action.payload,
      };
    case "UPDATE_EVENT_ID_DATA":
      return {
        ...state,
        eventId: action.payload,
      };
    case "UPDATE_PORTFOLIO_ID_DATA":
      return {
        ...state,
        portfolioId: action.payload,
      };
    case "UPDATE_CREATE_JOB_DATA":
      return {
        ...state,
        createJobData: action.payload,
      };
    case "UPDATE_NEWS_ID_DATA":
      return {
        ...state,
        newsId: action.payload,
      };
    case "UPDATE_MAIN_CATEGORY_ID_DATA":
      return {
        ...state,
        maincategoryId: action.payload,
      };
    case "UPDATE_JOB_ID_DATA":
      return {
        ...state,
        jobId: action.payload,
      };
    case "UPDATE_TEAM_DATA":
      return {
        ...state,
        teamData: action.payload,
      };
    case "UPDATE_CHAT_ID":
      return {
        ...state,
        chatId: action.payload,
      };
    case "UPDATE_USER_CHAT_DATA":
      return {
        ...state,
        userChatData: action.payload,
      };
    case "UPDATE_APPLICANTS_LISTS":
      return {
        ...state,
        applicants: action.payload,
      };
    case "UPDATE_EMAIL_VERIFIED_DATA":
      return {
        ...state,
        emailVerified: action.payload,
      };
    case "UPDATE_ROUTE_DATA":
      return {
        ...state,
        routeData: action.payload,
      };
    case "UPDATE_ACCESS_TOKEN":
      return {
        ...state,
        access_token: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
